import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative flex min-h-[540px] w-full items-center justify-center overflow-hidden md:min-h-[600px]">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20anime%20manga%20hero%20banner%20with%20dynamic%20ink%20brush%20strokes%2C%20silhouettes%20of%20action%20characters%2C%20warm%20orange%20and%20deep%20red%20sunset%20palette%2C%20abstract%20comic%20energy%20bursts%2C%20editorial%20artwork%2C%20high%20contrast%20and%20dramatic&width=1800&height=1000&seq=hero-manga-banner&orientation=landscape"
        alt="日漫最新话与连载情报更新横幅"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-background-950/70" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-16 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm text-white backdrop-blur-sm">
          <span className="h-2 w-2 animate-pulse rounded-full bg-accent-400" />
          今日已更新 <span className="font-semibold text-accent-300">12</span> 话
        </span>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-white md:text-6xl">
          日漫最新话 · 连载情报
          <br className="hidden md:block" />
          <span className="text-accent-400">一手抢先看</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          汇总日漫最新话、连载进度与更新动态，还有情报剧透与休刊提醒，让你第一时间掌握追更动态，不再错过任何一话。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/category/latest"
            className="inline-flex whitespace-nowrap w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-8 py-3.5 text-base font-semibold text-white transition-transform hover:scale-105 sm:w-auto"
          >
            开始追更
            <i className="ri-arrow-right-line text-lg" />
          </Link>
          <a
            href="#latest-updates"
            className="inline-flex whitespace-nowrap w-full items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-8 py-3.5 text-base font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto"
          >
            <i className="ri-flashlight-line text-lg" />
            查看最新话
          </a>
        </div>
      </div>
    </section>
  );
}